module.exports = "<h2 md-dialog-title>Message</h2>\n<div md-dialog-content>What would you like to do?</div>\n<div md-dialog-actions>\n  <button md-button (click)=\"dialogRef.close('1')\" color=\"accent\">Save</button>\n  <button md-button (click)=\"dialogRef.close('2')\" color=\"warn\">Cancel</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/material/material-dialog.html
// module id = ../../../../../src/app/pages/material/material-dialog.html
// module chunks = 39